import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { useSelector } from 'react-redux';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_GuestMessagingReservation_Update, gAPI_GuestMessagingReservation_ById, getAPI_GM_CommunicationChannel_All, } from '../../../../../../constants/APIs';
import moment from 'moment';
import EmailLogo from '../../../../../../assets/email_icon.png';
import WhatsApp_Logo from '../../../../../../assets/whatsapp_icon.svg';
import SMS_Logo from '../../../../../../assets/sms.svg';
import PhoneLogo from '../../../../../../assets/phone_icon.png';
import SendMessagePanel from '../components/SendMessagingManually/SendMessagePanel'
import countryCodes from '../../../../../../data/dial_code';

const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : null);
const parseDate = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
const capitalizeWords = (str) => {
    if (!str) return '';
    return str
        .toString()
        .toLowerCase()
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};

const validate = (...values) => values.find((v) => v !== undefined && v !== null && v !== '');

const RESERVATION_STATUS = [
    { label: 'Arrived', value: 'Arrived' },
    { label: 'Departed', value: 'Departed' },
    { label: 'Confirmed', value: 'Confirmed' },
    { label: 'Cancelled', value: 'Cancelled' },
]

export default function UpdateReservation({ row = {}, onSuccess, renderTrigger }) {
    const [isOpen, setIsOpen] = useState(false);
    const [arrivalDate, setArrivalDate] = useState(null);
    const [departureDate, setDepartureDate] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [middleName, setMiddleName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [countryCode, setCountryCode] = useState('+64');
    const [rawPhone, setRawPhone] = useState('');
    const [numAdults, setNumAdults] = useState('');
    const [numChildren, setNumChildren] = useState('');
    const [roomNumber, setRoomNumber] = useState('');
    const [roomTypeName, setRoomTypeName] = useState('');

    const [isSaving, setIsSaving] = useState(false);
    const [fetchedReservation, setFetchedReservation] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [reference, setReference] = useState('')
    const [bookingSource, setBookingSource] = useState('')
    const [reservationStatusPms, setReservationStatusPms] = useState('')
    const [error, setError] = useState({
        firstName: "",
        lastName: "",
        email: "",
        arrivalDate: "",
        departureDate: ""
    })

    const [isSendPanelOpen, setIsSendPanelOpen] = useState(false);
    const [activeSendTab, setActiveSendTab] = useState(null);

    const [selectedWhatsAppIntegrationId, setSelectedWhatsAppIntegrationId] = useState(null);
    const [selectedEmailIntegrationId, setSelectedEmailIntegrationId] = useState(null);
    const [selectedSMSIntegrationId, setSelectedSMSIntegrationId] = useState(null);
    const [selectedPhoneSuiteIntegrationId, setSelectedPhoneSuiteIntegrationId] = useState(null);

    const openSendPanel = (tab) => {
        setActiveSendTab(tab);
        setIsSendPanelOpen(true);
    };

    const { propertyId, groupId: storedGroupId, userName, timeZone } = useSelector(({ settings }) => ({
        propertyId: settings.propertyId,
        groupId: settings.groupId,
        userName: settings.userName,
        timeZone: settings.timeZone,
    }));

    const formatHeaderDateTime = (value, timeZone) => {
        console.log("timeZone", timeZone)
        if (!value) return '';
        return moment.utc(value).tz(timeZone).format('MMM DD, YYYY hh:mm a');
    };

    const groupId = useMemo(() => storedGroupId || getGroupID(), [storedGroupId]);

    const source = fetchedReservation || row.raw || row;

    const lastModified = useMemo(() => {
        return fetchedReservation?.lastModifiedUtc || source?.lastModifiedUtc || null;
    }, [fetchedReservation, source]);


    const reservationStatus = useMemo(() => {
        const status = validate(source.Status, source.status, row.status, '');
        return status ? capitalizeWords(status) : 'Update Reservation';
    }, [source, row]);


    const loadSelectedChannels = useCallback(async () => {
        if (!propertyId) return;

        try {
            const res = await AxiosAPI({
                method: 'get',
                url: getAPI_GM_CommunicationChannel_All,
            });

            const all = res.data || [];
            const propertyChannels = all.filter(
                (item) => item.propertyId === propertyId
            );

            const wa = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('what')
            );
            const email = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('email')
            );
            const sms = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('sms')
            );
            const AiVoice = propertyChannels.find((i) =>
                String(i.channel || '').toLowerCase().includes('phonesuite')
            );

            setSelectedWhatsAppIntegrationId(wa?.integrationId || null);
            setSelectedEmailIntegrationId(email?.integrationId || null);
            setSelectedSMSIntegrationId(sms?.integrationId || null);
            setSelectedPhoneSuiteIntegrationId(AiVoice?.integrationId || null);

        } catch (e) {
            console.error('Failed to load communication channels', e);
        }
    }, [propertyId]);

    const channelsLoadedRef = React.useRef(false);

    const hasWhatsApp = !!selectedWhatsAppIntegrationId
    const hasEmail = !!selectedEmailIntegrationId
    const hasSMS = !!selectedSMSIntegrationId
    const hasAiVoice = !!selectedPhoneSuiteIntegrationId

    useEffect(() => {
        if (!isOpen) {
            setFetchedReservation(null);
            return;
        }

        const fetchReservationData = async () => {
            if (!row.id) return;

            setIsFetching(true);
            try {
                const response = await AxiosAPI({
                    method: 'get',
                    url: `${gAPI_GuestMessagingReservation_ById}/${row.id}`,
                });
                setFetchedReservation(response.data);
            } catch (err) {
                NotificationManager.error('Failed to fetch reservation data', 'Error', 3000);
                console.error('Error fetching reservation:', err);
            } finally {
                setIsFetching(false);
            }
        };
        fetchReservationData();
        if (channelsLoadedRef.current) return;
        channelsLoadedRef.current = true;
        loadSelectedChannels();

    }, [isOpen, row.id,]);

    useEffect(() => {
        if (!isOpen || !source) return;

        setArrivalDate(parseDate(validate(source.ArrivalDate, source.arrivalDate)));
        setDepartureDate(parseDate(validate(source.DepartureDate, source.departureDate)));
        setFirstName(validate(source.NameFirst, source.nameFirst, row.displayName?.split(' ')[0], ''));
        setMiddleName(validate(source.NameMiddle, source.nameMiddle, ''));
        setLastName(validate(source.NameLast, source.nameLast, ''));
        setEmail(validate(source.EmailAddress, source.emailAddress, row.email));
        let pPhone = validate(source.PhoneMobile, source.phoneMobile, row.phone);
        if (pPhone) {
            let dialCode = '+64';
            let raw = pPhone;
            countryCodes.forEach((m) => {
                if (raw.startsWith(m.dial_code)) {
                    raw = raw.replace(m.dial_code, '');
                    dialCode = m.dial_code;
                }
            });
            setCountryCode(dialCode);
            setRawPhone(raw);
            setPhone(pPhone);
        } else {
            setPhone('');
            setRawPhone('');
        }

        const adultsValue = validate(source.NumberOfAdults, source.numberOfAdults, row.adults);
        const childrenValue = validate(source.NumberOfChildren, source.numberOfChildren, row.childrens);
        setNumAdults(adultsValue === undefined ? '' : String(adultsValue));
        setNumChildren(childrenValue === undefined ? '' : String(childrenValue));

        setRoomNumber(validate(source.RoomNumber, source.roomNumber, ''));
        setRoomTypeName(validate(source.RoomTypeName, source.roomTypeName, ''));
        setReference(validate(source.Reference, source.reference, ''))
        setBookingSource(validate(source.BookingSourceName, source.bookingSourceName))
        setReservationStatusPms(validate(source.reservationStatusPms, source.ReservationStatusPms))
    }, [isOpen, source, row]);

    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);

    const triggerNode = useMemo(() => {
        if (typeof renderTrigger === 'function') {
            return renderTrigger({ onClick: toggle, isOpen });
        }
        return (
            <Button color="primary" size="xs" outline className="px-3" onClick={toggle}>
                Edit
            </Button>
        );
    }, [renderTrigger, toggle, isOpen]);

    const handleUpdate = async () => {
        let newErrors = {};
        if (!firstName?.trim()) newErrors.firstName = "First name is mandatory";
        if (!lastName?.trim()) newErrors.lastName = "Last name is mandatory";
        if (!email?.trim()) newErrors.email = "Email is mandatory";

        if (!arrivalDate) newErrors.arrivalDate = "Arrival date is mandatory";
        if (!departureDate) newErrors.departureDate = "Departure date is mandatory";

        // Departure must be greater than arrival
        if (arrivalDate && departureDate) {
            if (moment(departureDate).isBefore(arrivalDate)) {
                newErrors.departureDate = "Departure date cannot be before arrival date";
            }
        }
        setError(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return;
        }
        if (!propertyId || !groupId) {
            NotificationManager.error('Select a property to continue', 'Error', 3000);
            return;
        }
        const payload = {
            ...(fetchedReservation || source),
            ReservationId: fetchedReservation?.id || source.id,
            ArrivalDate: formatDate(arrivalDate) || fetchedReservation?.ArrivalDate || source.ArrivalDate || null,
            DepartureDate: formatDate(departureDate) || fetchedReservation?.DepartureDate || source.DepartureDate || null,
            ArrivalEstimatedTime:
                arrivalDate ? moment(arrivalDate).format('HH:mm') : fetchedReservation?.ArrivalEstimatedTime || source.ArrivalEstimatedTime || '',
            DepartureEstimatedTime:
                departureDate ? moment(departureDate).format('HH:mm') : fetchedReservation?.DepartureEstimatedTime || source.DepartureEstimatedTime || '',
            NumberOfAdults: Number(numAdults) || 0,
            NumberOfChildren: Number(numChildren) || 0,
            RoomNumber: roomNumber || fetchedReservation?.RoomNumber || source.RoomNumber || '',
            RoomTypeName: roomTypeName || fetchedReservation?.RoomTypeName || source.RoomTypeName || '',
            Reference: reference || fetchedReservation?.Reference || source.Reference || '',
            BookingSourceName: bookingSource || fetchedReservation?.BookingSourceName || source.BookingSourceName || '',
            ReservationStatusPms: reservationStatusPms || fetchedReservation?.reservationStatusPms || source.ReservationStatusPms || '',
            NameFirst: firstName || fetchedReservation?.NameFirst || source.NameFirst || '',
            NameMiddle: middleName || fetchedReservation?.NameMiddle || source.NameMiddle || '',
            NameLast: lastName || fetchedReservation?.NameLast || source.NameLast || '',
            PhoneMobile: phone || fetchedReservation?.PhoneMobile || source.PhoneMobile || '',
            EmailAddress: email || fetchedReservation?.EmailAddress || source.EmailAddress || '',
            UpdatedBy: fetchedReservation?.UpdatedBy || source.UpdatedBy || userName || 'system',
        };

        setIsSaving(true);
        try {
            await AxiosAPI({
                method: 'put',
                url: putAPI_GuestMessagingReservation_Update,
                data: payload,
            });
            NotificationManager.success('Reservation updated successfully', 'Success', 3000);
            toggle();
            if (onSuccess) onSuccess();
        } catch (err) {
            NotificationManager.error('Failed to update reservation', 'Error', 3000);
        } finally {
            setIsSaving(false);
        }
    };


    const numberOptions = (min, max) => {
        const option = [<option key="default" value="">Select</option>];
        for (let i = min; i <= max; i += 1) {
            option.push(
                <option key={i} value={Number(i)}>
                    {i}
                </option>
            );
        }
        return option;
    };
    const reservationId = fetchedReservation?.id

    return (
        <>
            {triggerNode}
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                wrapClassName={`modal-right update-reservation-modal ${isSendPanelOpen ? 'with-send-panel' : ''}`}
                backdrop="static"
            >
                <ModalHeader toggle={toggle} style={{ padding: "22px" }}>
                    <span style={{ fontSize: "1rem" }}><b>{reservationStatus}</b></span>
                    {lastModified && (
                        <span style={{ fontSize: "0.9rem" }}><b>
                            {' '}({formatHeaderDateTime(lastModified, timeZone)})</b>
                        </span>
                    )}
                </ModalHeader>
                <ModalBody>
                    {isFetching ? (
                        <div className="loading" />
                    ) : (
                        <Row>
                            <Colxx sm={12}>
                                <h6 className="mt-1 mb-2">
                                    <b>Reservation Details</b>
                                </h6>
                            </Colxx>
                            <Colxx sm={6}>
                                <Label className="mt-2">Arrival Date <span style={{ color: "red" }}>*</span></Label>
                                <DatePicker
                                    selected={arrivalDate}
                                    onChange={(d) => {
                                        setArrivalDate(d);
                                        if (error.arrivalDate) setError({ ...error, arrivalDate: "" });
                                    }}
                                    placeholderText="arrival date"
                                    dateFormat="dd/MM/yyyy"
                                />
                                {error.arrivalDate && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.arrivalDate}</span>
                                )}
                            </Colxx>

                            <Colxx sm={6}>
                                <Label className="mt-2">Departure Date <span style={{ color: "red" }}>*</span></Label>
                                <DatePicker
                                    selected={departureDate}
                                    onChange={(d) => {
                                        setDepartureDate(d);
                                        if (error.departureDate) setError({ ...error, departureDate: "" });
                                    }}
                                    placeholderText="departure date"
                                    dateFormat="dd/MM/yyyy"
                                />
                                {error.departureDate && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.departureDate}</span>
                                )}
                            </Colxx>

                            <Colxx sm={6}>
                                <Label className="mt-2">Number of adults</Label>
                                <Input
                                    type="select"
                                    value={numAdults}
                                    onChange={(e) => setNumAdults(e.target.value)}
                                >
                                    {numberOptions(1, 6)}
                                </Input>
                            </Colxx>
                            <Colxx sm={6}>
                                <Label className="mt-2">Number of children</Label>
                                <Input
                                    type="select"
                                    value={numChildren}
                                    onChange={(e) => setNumChildren(e.target.value)}
                                >
                                    {numberOptions(0, 6)}
                                </Input>
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Room type</Label>
                                <Input
                                    type="text"
                                    value={roomTypeName}
                                    onChange={(e) => setRoomTypeName(e.target.value)}
                                    placeholder="Room type"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Room number</Label>
                                <Input
                                    type="text"
                                    value={roomNumber}
                                    onChange={(e) => setRoomNumber(e.target.value)}
                                    placeholder="Room number"
                                />
                            </Colxx>

                            <Colxx sm={12}>
                                <Label className="mt-2">Reference Number</Label>
                                <Input
                                    type="text"
                                    value={reference}
                                    onChange={(e) => setReference(e.target.value)}
                                    placeholder="Reference number"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Booking Source Name</Label>
                                <Input
                                    type="text"
                                    value={bookingSource}
                                    onChange={(e) => setBookingSource(e.target.value)}
                                    placeholder="Booking Source"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Reservation Status</Label>
                                <Input
                                    type="select"
                                    value={reservationStatusPms}
                                    onChange={(e) => setReservationStatusPms(e.target.value)}
                                >
                                    <option value="">Select Status</option>
                                    {RESERVATION_STATUS.map(status => (
                                        <option key={status.value} value={status.value}>
                                            {status.label}
                                        </option>
                                    ))}
                                </Input>

                            </Colxx>

                            <Colxx sm={12} className="mt-3">
                                <h6 className="mb-2">
                                    <b>Guest Details</b>
                                </h6>
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">First Name <span style={{ color: "red" }}>*</span></Label>
                                <Input className='input_sty' type="text" value={firstName}
                                    onChange={(e) => {
                                        setFirstName(e.target.value);
                                        if (error.firstName) setError({ ...error, firstName: "" });
                                    }}
                                    placeholder="First name"
                                />
                                {error.firstName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.firstName}</span>
                                )}
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Middle Name (Optional)</Label>
                                <Input
                                    type="text"
                                    value={middleName}
                                    onChange={(e) => setMiddleName(e.target.value)}
                                    placeholder="Middle name"
                                />
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Last Name <span style={{ color: "red" }}>*</span></Label>
                                <Input
                                    type="text"
                                    value={lastName}
                                    onChange={(e) => {
                                        setLastName(e.target.value);
                                        if (error.lastName) setError({ ...error, lastName: "" });
                                    }}
                                    placeholder="Last name"
                                />
                                {error.lastName && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.lastName}</span>
                                )}
                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Email Address <span style={{ color: "red" }}>*</span></Label>
                                <InputGroup>
                                    <Input
                                        type="email"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                            if (error.email) setError({ ...error, email: "" });
                                        }}
                                        placeholder="Email"
                                    />

                                    {hasEmail && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer' }}
                                                title="Send Email"
                                                onClick={() => {
                                                    openSendPanel('email')
                                                }}
                                            >
                                                <img src={EmailLogo} alt="Email" style={{ width: '1.2rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                                {error.email && (
                                    <span style={{ color: "red", fontSize: "12px" }}>{error.email}</span>
                                )}

                            </Colxx>
                            <Colxx sm={12}>
                                <Label className="mt-2">Phone Number</Label>
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend">
                                        <Input
                                            type="select"
                                            name="countryCode"
                                            value={countryCode}
                                            onChange={(e) => {
                                                const newCode = e.target.value;
                                                setCountryCode(newCode);
                                                setPhone(`${newCode}${rawPhone}`);
                                            }}
                                            style={{
                                                width: '125px',
                                                textAlign: 'center',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            {countryCodes.map((c) => (
                                                <option key={c.code} value={c.dial_code}>
                                                    {c.code} {c.dial_code} ({c.name})
                                                </option>
                                            ))}
                                        </Input>
                                    </InputGroupAddon>
                                    <Input
                                        type="text"
                                        value={rawPhone}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            setRawPhone(val);
                                            setPhone(`${countryCode}${val}`);
                                        }}
                                        placeholder="Phone"
                                    />

                                    {hasWhatsApp && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send WhatsApp"
                                                onClick={() => {
                                                    openSendPanel('whatsapp');
                                                }}
                                            >
                                                <img src={WhatsApp_Logo} alt="WhatsApp" style={{ width: '1.2rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}

                                    {hasSMS && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send SMS"
                                                onClick={() => {
                                                    openSendPanel('sms');
                                                }}
                                            >
                                                <img src={SMS_Logo} alt="Sms" style={{ width: '0.8rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                    {hasAiVoice && (
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText
                                                style={{ cursor: 'pointer', fontWeight: 'bold' }}
                                                title="Send AI Voice Message"
                                                onClick={() => {
                                                    openSendPanel('aivoice');
                                                }}
                                            >
                                                <img src={PhoneLogo} alt="AI Voice" style={{ width: '1rem' }} />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    )}
                                </InputGroup>
                            </Colxx>
                        </Row>
                    )}
                </ModalBody>


                <ModalFooter>
                    <Button color="primary" size="xs" onClick={handleUpdate} disabled={isSaving}>
                        Update
                    </Button>
                    <Button color="secondary" size="xs" outline onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            {isSendPanelOpen && (
                <SendMessagePanel
                    activeTab={activeSendTab}
                    onClose={() => setIsSendPanelOpen(false)}
                    preFillPhoneNumber={phone}
                    propertyId={propertyId}
                    showPhoneNumber={true}
                    reservationId={reservationId}
                    source="Manually"

                    reservationData={{
                        firstName,
                        lastName,
                        phone,
                        email,
                        roomNumber,
                        roomTypeName,
                        arrivalDate,
                        departureDate,
                    }}
                />
            )}

        </>
    );

}